"use client";
import { StatsigProvider, useClientAsyncInit } from "@statsig/react-bindings";
import { WindowEventListenersEnum } from "@/constants/constants";
import { useEffect } from "react";
import { setStatsigReady } from "@/utils/window.helpers";

interface StatsigWrapperProps {
  children: React.ReactNode;
}

export function StatsigWrapper({ children }: StatsigWrapperProps) {
  const { client } = useClientAsyncInit(
    process.env.NEXT_PUBLIC_STATSIG_CLIENT_KEY || "",
    {},
  );

  useEffect(() => {
    if (client.loadingStatus === "Ready") {
      setStatsigReady(true);
      const event = new CustomEvent(WindowEventListenersEnum.STATSIG_READY);
      window.dispatchEvent(event);
    }
  }, [client.loadingStatus]);

  return <StatsigProvider client={client}>{children}</StatsigProvider>;
}
